/****************************************************
 * Module Name:  mixBucketMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Avatar, Box, Button, Chip, Menu, MenuItem, Tooltip, Stack, Typography } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import AddMixBucketModal from "./addMixBucketModal";
import MixBucketProxy from "../../utility/proxy/manager/mixProxy/mixBucketProxy";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import AddUserModal from "../master/addUserModal";
import UserProxy from "../../utility/proxy/manager/userProxy";
import CommonSnackbar from "../common/commonSnackBar";
import AddPurchaseModal from "./addPurchaseModal";
import MixPurchaseProxy from "../../utility/proxy/manager/mixProxy/mixPurchaseProxy";
import AddSaleModal from "./addSaleModal";
import NoPermission from "../common/noPermission";
import MixSaleProxy from "../../utility/proxy/manager/mixProxy/mixSalesProxy";
import RevertMixBucketModal from "./revertMixBucketModal";
import DiamondIcon from '@mui/icons-material/Diamond';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import BucketDetailModal from "./bucketDetailModal";
import PageTitle from "../common/pageTitle";

export class MixBucketMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buckets:
        this.props.editButton && this.props.barSourceData
          ? this.props.barSourceData
          : this.props.apiType === "above"
            ? this.props.aboveData
            : this.props.apiType === "below"
              ? this.props.belowData
              : [],
      combinedFilterValues: {},
      showAddBucketModal: false,
      showAddUserModal: false,
      showAddPurchaseModal: false,
      showAddSellModal: false,
      loadingProformaButton: false,
      loadingInvoiceButton: false,
      userId: "",

      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      loadingButton: false,
      accesDenied: false,
      showBucketLoadSpinner: this.props.editButton ? false : true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET
      ),
      reactivate_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET_REACTIVATE
      ),
      showRevertModal: false,
      reactivateByStone: false,
      openMinUserMenuId: null,
      anchorEl: null,
      openMaxUserMenuId: null,
      anchorEl1: null,
      columnNames: [],

      selectedTotalSize: "",
      selectedAvgPPC: "",
      selectedTotalPrice: "",
      selectedAvgCost: "",
      selectedTotalCost: "",

      selectionModel: [],
      avgPricePermission: false,
      defaultSellPricePermission: false,

      showBucketDetailModal: false,
      bucketId: [],

      bucketIdPermission: false,
    };

    if (!this.props.editButton) {
      this.checkPermission();
    }
  }

  componentDidMount() {
    PageTitle("MIX_BUCKET");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchBucketData(false);
    }
  }


  fetchBucketData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showBucketLoadSpinner: true });
    MixBucketProxy.GetAllBucketDetail((responseData) => {
      const uniqueFilterValues = {
        shape: Utility.getDistinctOptions(responseData, "shape"),
        size: Utility.getDistinctOptions(responseData, "size"),
        color: Utility.getDistinctOptions(responseData, "color"),
        clarity: Utility.getDistinctOptions(responseData, "clarity"),
        stonetype: Utility.getDistinctOptions(responseData, "stonetypefullname"),
        maxalertusername: Utility.getDistinctOptions(responseData, "maxalertusername", item => `${item.userid} ${item.username}`),
      };

      const filterMap = this.generateFilterMap(Array.isArray(responseData) ? responseData : [responseData]);
      this.prepareColumns(uniqueFilterValues, filterMap);
      this.setState({
        buckets: responseData,
        combinedFilterValues: uniqueFilterValues,
        showBucketLoadSpinner: false,
      });

      this.loadBucketSummary(responseData, this.state.selectionModel);
    });
  };

  loadBucketSummary = (bucketDetails, newSelectionModel) => {
    let totalSize = 0;
    let totalPPC = 0;
    let totalCost = 0;
    if (newSelectionModel.length > 0) {
      bucketDetails.forEach(iBucket => {
        if (newSelectionModel.includes(iBucket.id)) {
          totalSize += iBucket.qty;
          totalPPC += iBucket.defaultsellprice * iBucket.qty;
          totalCost += iBucket.avgprice * iBucket.qty;
        }
      })
    } else {
      bucketDetails.forEach(iBucket => {
        totalSize += iBucket.qty;
        totalPPC += iBucket.defaultsellprice * iBucket.qty;
        totalCost += iBucket.avgprice * iBucket.qty;
      })
    }

    this.setState({
      selectedTotalSize: totalSize.toFixed(2),
      selectedAvgPPC: (totalPPC / totalSize).toFixed(2),
      selectedTotalPrice: totalPPC.toFixed(2),
      selectedAvgCost: (totalCost / totalSize).toFixed(2),
      selectedTotalCost: totalCost.toFixed(2)
    });
  }

  generateFilterMap = (responseData) => {
    const filterMap = {};

    // Process min alter username
    const minAlterUsername = responseData.flatMap((user) =>
      user.minalertusername.map((u) => ({
        id: u.id,
        username: u.username,
      }))
    );
    filterMap.minalertusername = [
      ...new Set(
        minAlterUsername.map((user) => `${user.id} | ${user.username}`)
      ),
    ];

    // Process max alter username
    const maxAlertUsername = responseData.flatMap((user) =>
      user.maxalertusername.map((u) => ({
        id: u.id,
        username: u.username,
      }))
    );
    filterMap.maxalertusername = [
      ...new Set(
        maxAlertUsername.map(
          (user) => `${user.id} | ${user.username}`
        )
      ),
    ];

    return filterMap;
  };


  prepareColumns = (combinedFilterValues, filterMap) => {
    let columnNames = [];


    Constants.USER_COLUMN_PERMISSION.forEach(iColumnPermission => {
      if (iColumnPermission === "f12c1ec3-2901-4368-ac5f-664720c5600c") {
        columnNames.push(
          {
            field: "id",
            headerName: "BUCKETID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 110,
            renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
              <Button
                sx={{
                  textDecorationLine: "underline",
                  color: 'black'
                }}
                onClick={() => this.handleBucketDetailModal(params)}
              >
                {params.value}
              </Button>
              :
              <div>{params.value}</div>,
          },
        );
      }
    })

    columnNames.push(
      {
        field: "stonetypefullname",
        headerName: "STONETYPE",
        headerAlign: "center",
        align: "center",
        width: 115,
        type: "singleSelect",
        valueOptions: combinedFilterValues ? combinedFilterValues.stonetype : [],
        filterOperators: Utility.combinedFilters(),
        valueGetter: (params) => params.value,
        renderCell: renderCellExpand,
      },
      {
        field: "shape",
        headerName: "SHAPE",
        headerAlign: "center",
        align: "center",
        width: 100,
        type: "singleSelect",
        valueOptions: combinedFilterValues ? combinedFilterValues.shape : [],
        filterOperators: Utility.combinedFilters(),
        renderCell: renderCellExpand,
        valueGetter: (params) => params.value,
      },
      {
        field: "size",
        headerName: "SIZE",
        headerAlign: "center",
        align: "right",
        width: 100,
        type: "singleSelect",
        valueOptions: combinedFilterValues ? combinedFilterValues.size : [],
        filterOperators: Utility.combinedFilters(),
        valueGetter: (params) => params.row.size,
        renderCell: renderCellExpand
      },
      {
        field: "color",
        headerName: "COLOR",
        headerAlign: "center",
        align: "center",
        width: 80,
        type: "singleSelect",
        valueOptions: combinedFilterValues ? combinedFilterValues.color : [],
        filterOperators: Utility.combinedFilters(),
        valueGetter: (params) => params.value,
        renderCell: renderCellExpand,
      },
      {
        field: "clarity",
        headerName: "CLARITY",
        headerAlign: "center",
        align: "center",
        width: 95,
        type: "singleSelect",
        valueOptions: combinedFilterValues ? combinedFilterValues.clarity : [],
        filterOperators: Utility.combinedFilters(),
        valueGetter: (params) => params.value,
        renderCell: renderCellExpand,
      },
    );

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (this.columnsData.hasOwnProperty(iColPermission)) {
        const columnData = this.columnsData[iColPermission];
        if (columnData.field === "avgprice") {
          this.setState({ avgPricePermission: true });
        }
        if (columnData.field === "defaultsellprice") {
          this.setState({ defaultSellPricePermission: true });
        }
        if (columnData.field !== "minalertusername" && columnData.field !== "maxalertusername")
          columnNames.push(columnData);
      }
    });

    columnNames.push(
      {
        field: "reactivate",
        headerName: "RE-ACTIVATE",
        headerAlign: "center",
        align: "center",
        width: 120,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Box>
              <Tooltip title="BY STONE" arrow>
                <DiamondIcon
                  cursor={"pointer"}
                  sx={{
                    fontSize: "26px"
                  }}
                  onClick={() => {
                    this.setState({
                      reactivateByStone: true,
                      showRevertModal: true,
                      sourceData: params.row,
                    });
                  }}
                />
              </Tooltip>
              <HorizontalRuleIcon
                sx={{
                  fontSize: "28px",
                  rotate: "90deg"
                }}
              />
              <Tooltip title="BY EXCEL" arrow>
                <UploadFileIcon
                  cursor={"pointer"}
                  sx={{
                    fontSize: "26px"
                  }}
                  onClick={() => {
                    this.setState({
                      reactivateByStone: false,
                      showRevertModal: true,
                      sourceData: params.row,
                    });
                  }}
                />
              </Tooltip>
            </Box>
          );
        },
      },
      {
        field: "purchase",
        headerName: "PURCHASE",
        headerAlign: "center",
        align: "center",
        width: 140,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Button
              variant="contained"
              size="small"
              color="success"
              onClick={() => {
                this.setState({
                  showAddPurchaseModal: true,
                  editOperation: true,
                  sourceData: params.row,
                });
              }}
            >
              Purchase
            </Button>
          );
        },
      },
      {
        field: "sell",
        headerName: "SELL",
        headerAlign: "center",
        align: "center",
        width: 100,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Button
              color="error"
              size="small"
              variant="contained"
              style={{ textAlign: "center", cursor: "pointer" }}
              onClick={() => {
                this.setState({
                  showAddSellModal: true,
                  bucketData: params.row,
                });
              }}
              disabled={!params.row.qty}
            >
              Sell
            </Button>
          );
        },
      },
      {
        field: "edit",
        headerName: "EDIT",
        headerAlign: "center",
        align: "center",
        width: 60,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Box
              style={{ textAlign: "center", cursor: "pointer" }}
              onClick={() => {
                this.setState({
                  showAddBucketModal: true,
                  editOperation: true,
                  sourceData: params.row,
                  loadingButton: false,
                });
              }}
            >
              {" "}
              <BorderColorIcon color="primary" />
            </Box>
          );
        },
      },
    );

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (this.columnsData.hasOwnProperty(iColPermission)) {
        const columnData = this.columnsData[iColPermission];
        if (columnData.field === "minalertusername") {
          columnData.type = "singleSelect";
          columnData.valueOptions = filterMap ? filterMap.minalertusername : [];
          columnData.filterOperators = Utility.customFilters(filterMap, columnData.field, 'id', 'username');
          columnNames.push(columnData);
        }
        if (columnData.field === "maxalertusername") {
          columnData.type = "singleSelect";
          columnData.valueOptions = filterMap ? filterMap.maxalertusername : [];
          columnData.filterOperators = Utility.customFilters(filterMap, columnData.field, 'id', 'username');
          columnNames.push(columnData);
        }
      }
    });

    this.setState({
      columnNames: columnNames
    });
  }

  handleBucketDetailModal = (params) => {
    this.setState({ showBucketDetailModal: true, bucketId: params.value });
  };

  handleMinUserMenuClick = (event, id) => {
    this.setState({
      anchorEl: event.currentTarget,
      openMinUserMenuId: id,
    });
  };

  handleMinUserMenuClose = () => {
    this.setState({
      anchorEl: null,
      openMinUserMenuId: null,
    });
  };

  handleMaxUserMenuClick = (event, id) => {
    this.setState({
      anchorEl1: event.currentTarget,
      openMaxUserMenuId: id,
    });
  };

  handleMaxUserMenuClose = () => {
    this.setState({
      anchorEl1: null,
      openMaxUserMenuId: null,
    });
  };

  columnsData = {
    "81ef77f7-d366-447a-a68d-86664f04c8ae": {
      field: "defaultpurchaseprice",
      headerName: "DEFAULT PURCHASE PRICE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 210
    },
    "3e264059-af48-45e5-917a-fb1b971db4b6": {
      field: "defaultsellprice",
      headerName: "DEFAULT SELL PRICE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 185
    },
    "45e76150-8506-4e5c-9e00-04812830404b": {
      field: "minalertqty",
      headerName: "MIN ALERT QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 130,
      renderCell: renderCellExpand,
    },
    "e38095be-101d-45ed-9a10-aef1aba03f8c": {
      field: "maxalertqty",
      headerName: "MAX ALERT QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 130,
      renderCell: renderCellExpand,
    },
    "809a4ec3-4c31-4077-b96d-97d53d57efac": {
      field: "avgprice",
      headerName: "AVG PRICE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 100,
      renderCell: renderCellExpand,
    },
    "03c60e42-31d0-4b12-b8f0-d7e141ae6c28": {
      field: "qty",
      headerName: "QUANTITY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 95,
      renderCell: renderCellExpand,
    },
    "7b076812-4af4-462e-abcb-1eee8f44d740": {
      field: "minalertusername",
      headerName: "MIN ALERT USERNAME",
      headerAlign: "center",
      align: "center",
      width: 160,
      sortable: false,
      valueGetter: (params) => params.value,
      renderCell: (params) => params.value.length === 0 ? null : (
        <Box>
          <Button
            aria-controls={this.state.openMinUserMenuId === params.id ? 'role-minuser-menu' : undefined}
            aria-haspopup="true"
            onClick={(event) => this.handleMinUserMenuClick(event, params.id)}
          >
            View User
          </Button>
          <Menu
            id="role-minuser-menu"
            anchorEl={this.state.anchorEl}
            open={this.state.openMinUserMenuId === params.id}
            onClose={this.handleMinUserMenuClose}
            sx={{
              height: "40rem"
            }}
          >
            {params.value.map((item, index) => (
              <MenuItem>
                <Chip
                  key={index}
                  avatar={<Avatar>{item.id}</Avatar>}
                  label={item.username}
                  onClick={() => {
                    this.setState({
                      showAddUserModal: true,
                      editOperation: false,
                      sourceData: undefined,
                      userId: item.id,
                      openMinUserMenuId: null,
                      anchorEl: null
                    });
                  }}
                  sx={{ margin: "0px 10px 10px 0px" }}
                />
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ),
      disableExport: true,
    },
    "5a220faa-49a0-403b-8c1a-2e001d7721be": {
      field: "maxalertusername",
      headerName: "MAX ALERT USERNAME",
      headerAlign: "center",
      align: "center",
      width: 160,
      sortable: false,
      valueGetter: (params) => params.value,
      renderCell: (params) => params.value.length === 0 ? null : (
        <Box>
          <Button
            aria-controls={this.state.openMaxUserMenuId === params.id ? 'role-maxuser-menu' : undefined}
            aria-haspopup="true"
            onClick={(event) => this.handleMaxUserMenuClick(event, params.id)}
          >
            View User
          </Button>
          <Menu
            id="role-maxuser-menu"
            anchorEl={this.state.anchorEl1}
            open={this.state.openMaxUserMenuId === params.id}
            onClose={this.handleMaxUserMenuClose}
            sx={{
              height: "40rem"
            }}
          >
            {params.value.map((item, index) => (
              <MenuItem>
                <Chip
                  key={index}
                  avatar={<Avatar>{item.id}</Avatar>}
                  label={item.username}
                  onClick={() => {
                    this.setState({
                      showAddUserModal: true,
                      editOperation: false,
                      sourceData: undefined,
                      userId: item.id,
                      openMaxUserMenuId: null,
                      anchorEl1: null
                    });
                  }}
                  sx={{ margin: "0px 10px 10px 0px" }}
                />
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ),
      disableExport: true
    },
  }


  hideAddBucketModal = () => {
    this.setState({
      showAddBucketModal: false,
      showBucketDetailModal: false,
    });
  };

  hideAddPurchaseModal = () => {
    this.setState({
      showAddPurchaseModal: false,
    });
  };

  handleValidation = (bucketData) => {
    //TODO do validation if needed here
    return true;
  };

  addBucket = (bucketData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating Bucket, and once bucket is updated on call refresh the list of current buckets
      MixBucketProxy.UpdateBucket(bucketData, (response) => {
        if (response) {
          this.fetchBucketData(true);
          this.setState({ loadingButton: false });
          //Hidding bucket modal
          this.hideAddBucketModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    } else {
      //Creating new Bucket, and once bucket is created on call refresh the list of current buckets
      MixBucketProxy.AddBucket(bucketData, (response) => {
        if (response) {
          this.fetchBucketData(true);
          this.setState({ loadingButton: false });
          //Hidding bucket modal
          this.hideAddBucketModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  hideAddUserModal = () => {
    this.setState({ showAddUserModal: false });
  };

  editUser = (userData) => {
    this.setState({ loadingButton: true });
    UserProxy.UpdateUser(userData, (response) => {
      if (response) {
        this.hideAddUserModal();
        this.setState({ loadingButton: false });
      } else {
        this.setState({ errorSnackbar: true });
        this.setState({ loadingButton: false });
      }
    });
  };

  addPurchase = (purchaseData) => {
    this.setState({ loadingButton: true });
    //Creating new Purchase, and once purchase is created on call refresh the list of current purchases
    MixPurchaseProxy.AddPurchase(purchaseData, (responseData) => {
      if (responseData) {
        this.setState({ loadingButton: false, showAddPurchaseModal: false });
        this.fetchBucketData(true);
      } else {
        this.setState({ loadingButton: false, errorSnackbar: true });
      }
    });
  };

  mixSellInvoice = (saleData) => {
    this.setState({ loadingInvoiceButton: true });
    //Creating new Sale, and once sale is created on call refresh the list of current sales
    MixSaleProxy.MixSellInvoice(saleData, (response) => {
      if (response) {
        this.setState({
          loadingInvoiceButton: false,
          showAddSellModal: false,
          successSnackbar: true,
          snackbarMsg: "Invoice Created Successfully"
        });
        this.fetchBucketData(true);
      } else {
        this.setState({ loadingInvoiceButton: false, errorSnackbar: true });
      }
    });
  };

  mixSellProforma = (saleData) => {
    this.setState({ loadingProformaButton: true });
    //Creating new Sale, and once sale is created on call refresh the list of current sales
    MixSaleProxy.MixSellProforma(saleData, (response) => {
      if (response) {
        this.setState({
          loadingProformaButton: false,
          showAddSellModal: false,
          successSnackbar: true,
          snackbarMsg: "Proforma Created Successfully",
        });
        this.fetchBucketData(true);
      } else {
        this.setState({ loadingProformaButton: false, errorSnackbar: true });
      }
    });
  };

  mixRemoveStoneFromBucket = (lstStoneIds, bucketid) => {
    this.setState({ loadingButton: true });
    MixBucketProxy.DeleteStonesFromBucketId(lstStoneIds, bucketid, (response) => {
      if (response.status === "Success") {
        this.setState({
          showRevertModal: false,
          successSnackbar: true,
          snackbarMsg: "Stone removed from Bucket Successfully",
          loadingButton: false
        });
        this.fetchBucketData(true);
      } else {
        this.setState({
          showRevertModal: false,
          errorSnackbar: true,
          loadingButton: false
        });
      }
    })
  }

  mixRemoveBulkStoneFromBucket = (lstStones, bucketid) => {
    this.setState({ loadingButton: true });
    MixBucketProxy.DeleteBulkStonesFromBucketId(lstStones, bucketid, (response) => {
      if (response.status === "Success") {
        this.setState({
          showRevertModal: false,
          successSnackbar: true,
          snackbarMsg: "Stone removed from Bucket Successfully",
          loadingButton: false
        });
        this.fetchBucketData(true);
      } else {
        this.setState({
          showRevertModal: false,
          errorSnackbar: true,
          loadingButton: false
        });
      }
    })
  }

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              minWidth: 0,
              px: 1,
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              useFlexGap
              flexWrap="wrap"
              sx={{
                width: "100%",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: { xs: "flex-start", sm: "flex-start" },
              }}
            >
              <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                Total Weight: <b>{this.state.selectedTotalSize}</b>
              </Typography>

              {this.state.defaultSellPricePermission && (
                <>
                  <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                    Avg PPC: <b>{this.state.selectedAvgPPC}</b>
                  </Typography>
                  <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                    Total Price: <b>{this.state.selectedTotalPrice}</b>
                  </Typography>
                </>
              )}

              {this.state.avgPricePermission && (
                <>
                  <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                    Avg Cost: <b>{this.state.selectedAvgCost}</b>
                  </Typography>
                  <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                    Total Cost: <b>{this.state.selectedTotalCost}</b>
                  </Typography>
                </>
              )}
            </Stack>
          </Box>


          {this.state.showBucketLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchBucketData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}
          {Utility.isAddAllowed(this.state.local_Permission) &&
            !this.props.editButton ? (
            <Tooltip title="Add Bucket">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddBucketModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Bucket
              </Button>
            </Tooltip>
          ) : null}

          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed && !this.props.editButton) {
      return <NoPermission />
    }

    const hasReactivatePermission =
      Utility.isReadAllowed(this.state.reactivate_Permission) ||
      Utility.isAddAllowed(this.state.reactivate_Permission) ||
      Utility.isUpdateAllowed(this.state.reactivate_Permission) ||
      Utility.isDeleteAllowed(this.state.reactivate_Permission);

    const rows = this.state.buckets;

    const columns = Utility.isUpdateAllowed(this.state.local_Permission) && !this.props.editButton
      ? hasReactivatePermission
        ? this.state.columnNames
        : this.state.columnNames.filter((col) => col.field !== "reactivate")
      : hasReactivatePermission
        ? this.state.columnNames.filter(
          (col) =>
            col.field !== "edit" &&
            col.field !== "sell" &&
            col.field !== "purchase"
        )
        : this.state.columnNames.filter((col) => col.field !== "reactivate" &&
          col.field !== "edit" &&
          col.field !== "sell" &&
          col.field !== "purchase")

    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />

        <CommonSnackbar
          show={this.state.successSnackbar}
          message={this.state.snackbarMsg}
          variant={"success"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ successSnackbar: false })}
          title="Success"
        />

        {this.state.showBucketDetailModal ? (
          <BucketDetailModal
            show={this.state.showBucketDetailModal}
            bucketId={this.state.bucketId}
            handleClose={this.hideAddBucketModal}
          />
        ) : null}


        <br />
        {this.state.showAddBucketModal ? (
          <AddMixBucketModal
            Show={true}
            handleClose={this.hideAddBucketModal}
            handleSave={this.addBucket}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
            saveButton={!this.props.editButton}
          />
        ) : null}

        {this.state.showRevertModal ? (
          <RevertMixBucketModal
            show={true}
            handleClose={() => this.setState({ showRevertModal: false })}
            handleRemove={this.mixRemoveStoneFromBucket}
            handleBulkRemove={this.mixRemoveBulkStoneFromBucket}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
            reactivateByStone={this.state.reactivateByStone}
          />
        ) : null}

        {this.state.showAddPurchaseModal ? (
          <AddPurchaseModal
            show={true}
            handleClose={this.hideAddPurchaseModal}
            handleSave={this.addPurchase}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : null}

        {this.state.showAddUserModal ? (
          <AddUserModal
            Show={true}
            handleClose={this.hideAddUserModal}
            handleSave={this.editUser}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            userId={this.state.userId}
            loading={this.state.loadingButton}
            saveButton={!this.props.editButton}
          />
        ) : null}

        {this.state.showAddSellModal ? (
          <AddSaleModal
            show={true}
            setShow={() => this.setState({ showAddSellModal: false })}
            handleValidation={this.handleValidation}
            handleInvoice={this.mixSellInvoice}
            handleProforma={this.mixSellProforma}
            bucketData={this.state.bucketData}
            user={Constants.loggedInUser.id + " | " + Constants.loggedInUser.companyname}
            proformaButton={true}
            loading={this.state.loadingInvoiceButton}
            loadingProformaButton={this.state.loadingProformaButton}
            bucketDisabled={true}
          />
        ) : null}

        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "83vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => 'auto'}
              autoHeight={!this.props.editButton ? false : true}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              density="compact"
              columns={columns}
              getRowId={(row) => row.id}
              checkboxSelection={true}
              onRowSelectionModelChange={(newSelectionModel) => {
                this.setState({ selectionModel: newSelectionModel });
                this.loadBucketSummary(this.state.buckets, newSelectionModel);
              }}
              rowSelectionModel={this.state.selectionModel}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns id, the other columns will remain visible
                    id: false
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              loading={this.state.showBucketLoadSpinner}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default MixBucketMaster;
